// src/helpers/auth.helper.js
import axios from "axios"
import { login, logout } from "../../data/AuthSlice"

export const attemptTokenRefresh = async (dispatch) => {
  try {
    await axios.get("/api/auth/refresh", { withCredentials: true })
    const res = await axios.get("/api/auth/me", { withCredentials: true })
    dispatch(login(res.data.user))
    return true
  } catch (err) {
    dispatch(logout())
    return false
  }
}
